export default "__VITE_ASSET__DsftOwJf__"